export function handleExcelReportUrlParams(pagination, historyTabDownload, headerTabUpdate) {
  const urlParams = new URLSearchParams(window.location.search);
  const excelReport = urlParams.get('excelReport');

  if (excelReport) {
    pagination.value.type = historyTabDownload;
    pagination.value.tab = headerTabUpdate;
  }
}